<template>
  <div id="parklist-actions">
    <div class="router" >
      <router-view />
    </div>

    <FilterSection :actions="parks" :filters="filters" :page="page" />
  </div>
</template>

<script>
import FilterSection from "@/components/FilterSection.vue";

export default {
  props: {
    parks: Array,
    filters: Object,
  },
  data() {
    return {
      page: 1
    }
  },
  computed: {
  },
  components: {
    FilterSection,
  },
  watch: {
    $route(to) {
      // console.log('to: ', to, 'from: ', from)
      let params = to.params

      this.page = params.page || 1
    }
  },
};
</script>

<style lang="scss">
  #mainColMain .viewTabs .tabsContainer .tab.tabsWrapper .content .tabContent{
    border:none
  }
</style>
